module.exports = __webpack_public_path__ + "img/carousel1.d77e9ca9.png";